import { Type } from '@angular/core';

import { AbstractFormFieldComponent } from '../../../Common/PageBuilder/components/FormField/abstract-form-field.component';
import { FormFieldModel } from '../../../Common/PageBuilder/models/form-field.model';

export class CuratedAdditionalSettingsField implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>
    ) {
        this.fieldComponent = fieldComponent;
        // this property is not used on any model
        this.property = 'curatedAdditionalSettingsField';
    }
}
